<template lang="pug">
.row
  .col-12.mb-3
    ul#my-tab.nav.nav-tabs(role='tablist')
      li.nav-item(role='presentation')
        router-link.nav-link(
          :class='{ active: isTabActive("manageapplications") }'
          :to='{ name: "account.developer.manageapplications" }'
        ) {{ $t('pages.developerPage.manageApplications') }}
      li.nav-item(role='presentation')
        router-link.nav-link(
          :class='{ active: isTabActive("documentation") }'
          :to='{ name: "account.developer.documentation" }'
        ) {{ $t('pages.developerPage.documentation') }}
      li.nav-item(role='presentation')
        router-link.nav-link(
          :class='{ active: isTabActive("webhooks") }'
          :hidden='isTabActive("webhookevents")'
          :to='{ name: "account.developer.webhooks" }'
        ) {{ $t('pages.manageWebhooks.title') }}
        router-link.nav-link(
          :class='{ active: isTabActive("webhookevents") }'
          :hidden='!isTabActive("webhookevents")'
          :to='{ name: "account.developer.webhookevents" }'
        ) {{ title }}
    #myTabContent.tab-content.pt-3
      router-view
</template>

<script>
export default {
  name: 'DeveloperPage',
  computed: {
    title() {
      return (
        this.$route.query.webhook || this.$t('pages.manageWebhookEvents.title')
      );
    },
  },
  methods: {
    getRouteName() {
      return this.$route.name.split('.').pop();
    },
    isTabActive(type) {
      return this.getRouteName() === type;
    },
  },
};
</script>
